// eslint-disable-next-line no-shadow
enum EChangeOperation {
    INSERT = 1,
    UPDATE = 2,
    DELETE = 3,
}

export default EChangeOperation
